"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@material-ui/core");

var react_1 = __importDefault(require("react"));

var customerDetailsBlockStyles = core_1.createStyles(function (theme) {
  return {
    block: {
      display: "grid",
      minHeight: "0"
    },
    paragraph: {
      fontSize: "22px",
      margin: "4px 0",
      maxHeight: "100%",
      maxWidth: "100%",
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap"
    }
  };
});

var BB8SummaryBlock = function BB8SummaryBlock(_a) {
  var id = _a.id,
      children = _a.children,
      title = _a.title,
      details = _a.details,
      _b = _a.type,
      type = _b === void 0 ? "default" : _b,
      classes = _a.classes;
  return react_1.default.createElement("div", {
    id: id,
    className: classes.block,
    style: {
      alignItems: "center",
      gridArea: type,
      gridTemplateColumns: type === "default" ? "100%" : "90px 45px",
      gridTemplateRows: type === "default" ? "14px 30px" : "auto",
      margin: type === "default" ? "12px 0" : "0"
    }
  }, children ? children : react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("small", null, title), react_1.default.createElement("p", {
    className: classes.paragraph,
    title: details
  }, details)));
};

exports.default = core_1.withStyles(customerDetailsBlockStyles)(BB8SummaryBlock);